import React from "react";
import "../styles/Foundation.css";

function Foundation() {
  return (
    <section id="foundation" className="foundation-section">
      <div className="section-container foundation-container">
        {/* Left side: text */}
        <div className="foundation-image">
          <img src="/Foundation.jpeg" alt="About Nyayom Legal Services" />
        </div>
        {/* Right side: image */}
        <div className="foundation-text">
          <h2>Our Foundation</h2>
          <p>
            Our practice stands on two strong pillars:
          </p>
          <div className="foundation-text-explain">
            <ul>
              <li>
                Sound Legal Logic
              </li>
              <li>
                Just, Fair Ethics
              </li>
            </ul>
          </div>
          <p>
            These principles are symbolised by the advocate neck bands wrapped around the two "Y"s in our logo—a visual commitment to the standards we uphold.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Foundation;